import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a1c3a31&"
import script from "./image-slider.js?vue&type=script&lang=js&"
export * from "./image-slider.js?vue&type=script&lang=js&"
import style0 from "./image-slider.scss?vue&type=style&index=0&lang=.%2Fimage-slider.scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports